<template>
  <div>
    <dd-vertical-sub-tabs-layout horizontal v-if="!loading">
      <template v-slot:tabs>
        <dd-sub-tab-group>
          <dd-sub-tab
            v-for="mortgage in mortgages"
            :key="mortgage.hypotheeknummer"
            orientation="horizontal"
          >
            {{ mortgage.hypotheeknummer }}
          </dd-sub-tab>
        </dd-sub-tab-group>
      </template>
      <template v-slot:content>
        <dd-sub-tab-content-wrapper>
          <dd-sub-tab-content
            v-for="mortgage in mortgages"
            :key="mortgage.hypotheeknummer"
          >
            <MortgageRefinance :mortgage-id="mortgage.id"></MortgageRefinance>
          </dd-sub-tab-content>
        </dd-sub-tab-content-wrapper>
      </template>
    </dd-vertical-sub-tabs-layout>
    <dd-loading-indicator v-else/>
  </div>
</template>

<script>
import MortgageRefinance from "~/modules/compare/MortgageRefinance.vue";
import mortgageApi from "~/api/mortgage";

export default {
  props: {
    customerId: [String, Number],
  },

  data() {
    return {
      mortgages: null,
      loading:false,
    };
  },

  components: {
    MortgageRefinance,
  },

  async mounted() {
    this.loading = true;
    try {
      let response = await mortgageApi.getByCustomer(this.customerId);

      this.mortgages = response.data.data;
    } finally {
      this.loading = false;
    }
  },

  computed: {},
};
</script>

<style scoped></style>
